import { render, staticRenderFns } from "./RuleEditor.vue?vue&type=template&id=7c64dbfc&scoped=true"
import script from "./RuleEditor.vue?vue&type=script&lang=js"
export * from "./RuleEditor.vue?vue&type=script&lang=js"
import style0 from "./RuleEditor.vue?vue&type=style&index=0&id=7c64dbfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c64dbfc",
  null
  
)

export default component.exports